module.exports = "<div class=\"etl-container\">\r\n  <app-etl-list></app-etl-list>\r\n</div>\r\n"